import { Container, Row, Col } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import LoadingSpinner from "../global/LoadingSpinner";
import { useGetCompereCountAndAverageScore, useGetCountAndAverageScore, useGetDetailedRatings, useGetHighestRatings, useGetNpsScore, useScoreStatistics } from "../../hooks/statistic/Feedback";
import ScoreDistributionTile from "../dashboard/ScoreDistributionTile";
import { useEffect, useState } from "react";
import SingleDataTile from "../dashboard/SingleDataTile";
import { calculateDifference, calculateDifference2, calculateNpsDifference } from "../../helpers/templateHelpers";
import StarElementsTileContainer from "./StarElementsTileContainer";


function ModuleReportStatistic({ module, baseDate, compareDate }) {
  const { t, i18n } = useTranslation();

  const lang = i18n.language;

  const from = baseDate?.startDate?.valueOf();
  const to = baseDate?.endDate?.valueOf();
  const compareFrom = compareDate?.startDate?.valueOf();
  const compareTo = compareDate?.endDate?.valueOf();
  const moduleId = (module?.company) ? '' : module?.id || 'ALL';

  const { data: score, isLoading: scoreIsLoading, isError: scoreIsError, refetch: scoreRefetch, isFetching: scoreIsFetching } = useGetCountAndAverageScore(moduleId, '', from, to, 'score');
  const { data: compareScore, isLoading: compareIsLoading, isError: compareIsError, refetch: compareRefetch, isFetching: compareScoreIsFetching } = useGetCompereCountAndAverageScore(moduleId, '', compareFrom, compareTo, 'compareScore');
  const { data: scoreStatistics, isLoading: scoreStatisticsIsLoading, isError: scoreStatisticsIsError, refetch: scoreStatisticsRefetch, isFetching: scoreStatisticsIsFetching } = useScoreStatistics(moduleId, '', from, to, 'scoreStatistics');
  const { data: nps, isLoading: npsIsLoading, isError: npsIsError, refetch: npsRefetch, isFetching: npsIsFetching } = useGetNpsScore(moduleId, '', from, to, 'nps');
  const { data: compareNps, isLoading: compareNpsIsLoading, isError: compareNpsIsError, refetch: compareNpsRefetch, isFetching: compareNpsIsFetching } = useGetNpsScore(moduleId, '', compareFrom, compareTo, 'compareNps');
  const { data: detailedRatings, isLoading: detailedRatingsIsLoading, isError: detailedRatingsIsError, refetch: detailedRatingsRefetch, isFetching: detailedRatingsIsFetching } = useGetDetailedRatings(moduleId, '', from, to, 'detailedRatings');
  const { data: comparDetailedRatings, isLoading: comparDetailedRatingsIsLoading, isError: comparDetailedRatingsIsError, refetch: comparDetailedRatingsRefetch, isFetching: comparDetailedRatingsIsFetching } = useGetDetailedRatings(moduleId, '', compareFrom, compareTo, 'comparDetailedRatings');
  const { data: highetRatings, isLoading: highestRatingsIsLoading, isError: highestRatingsIsError, refetch: highestRatingsRefetch, isFetching: highetRatingsIsFetching } = useGetHighestRatings(moduleId, '', from, to, 'highetRatings');



  const [reviewsStatistics, setReviewsStatistics] = useState({ avgRating: 0, compAvgRating: 0, nps: 0, compNpsCount: 0, avgAbsoluteDifference: 0, count: 0, compCount: 0 });


  useEffect(() => {
    if (module || baseDate || compareDate) {
      scoreRefetch();
      compareRefetch();
      scoreStatisticsRefetch();
      npsRefetch();
      compareNpsRefetch();
      detailedRatingsRefetch();
      comparDetailedRatingsRefetch();
      highestRatingsRefetch();
    }
  }, [module, baseDate, compareDate]);

  useEffect(() => {
    if (score) {
      setReviewsStatistics({ ...reviewsStatistics, avgRating: Number(score.score), count: Number(score.count), avgAbsoluteDifference: calculateDifference2(score.score, compareScore?.score ?? 0), compCount: Number(compareScore?.count ?? 0) });
    }
  }, [score]);



  //if (scoreIsLoading || scoreStatisticsIsLoading || compareIsLoading || npsIsLoading || compareNpsIsLoading || detailedRatingsIsLoading || comparDetailedRatingsIsLoading || highestRatingsIsLoading) return <LoadingSpinner className="my-5" />
  //if (scoreIsFetching || scoreStatisticsIsFetching || compareScoreIsFetching || npsIsFetching || compareNpsIsFetching || detailedRatingsIsFetching || comparDetailedRatingsIsFetching || highetRatingsIsFetching) return <LoadingSpinner className="my-5" />
  //if (scoreIsError || scoreStatisticsIsError || compareIsError || npsIsError || compareNpsIsError || detailedRatingsIsError || comparDetailedRatingsIsError || highestRatingsIsError) return 'An error has occurred: ' + scoreIsError.message;


  return (
    <Container>
      <Row>
        <Col md={4} className="adminReportMainTile">
          <div className="MainTileWrap">
            {scoreStatisticsIsFetching && <div className="adminReportOverlay">
              <LoadingSpinner className="my-5" />
            </div>}
            {(
              <ScoreDistributionTile
                showheader={true}
                showDifference={compareFrom ? true : false}
                reviewsStatistics={reviewsStatistics}
                showTitleTile={true}
                hidePercentage={false}
                rate1Count={parseInt(scoreStatistics?.[0]?.count) ?? 0}
                rate2Count={parseInt(scoreStatistics?.[1]?.count) ?? 0}
                rate3Count={parseInt(scoreStatistics?.[2]?.count) ?? 0}
                rate4Count={parseInt(scoreStatistics?.[3]?.count) ?? 0}
                rate5Count={parseInt(scoreStatistics?.[4]?.count) ?? 0}
              />
            )}
          </div>
        </Col>
        <Col md={8}>
          <Row>
            <Col sm={6} className=" adminReportSecTile">
              <div className="MainTileWrap">
                {scoreIsFetching && <div className="adminReportOverlay"><LoadingSpinner className="my-5" /></div>}
                <SingleDataTile
                  className={"tile tileBasic tileBasicEarth"}
                  title={t("admin.common.colOpi", {
                    count: Math.round(10),
                  })}
                  value={score?.count ?? 0}
                  decimalPlaces={1}
                  difference={compareFrom ? calculateDifference(score?.count ?? 0, compareScore?.count ?? 0) : NaN}
                  hidePercentage={false}
                  showDifference={true}
                />
              </div>
            </Col>

            <Col sm={6} className=" adminReportSecTile">
            <div className="MainTileWrap">
                {npsIsFetching && <div className="adminReportOverlay"><LoadingSpinner className="my-5" /></div>}
              <SingleDataTile
                className={"tile tileBasic tileBasicStar"}
                title={t("priceList.tt8")}
                decimalPlaces={1}
                value={nps?.score ?? 0}
                difference={compareFrom ? calculateNpsDifference(nps?.score ?? 0, compareNps?.score ?? 0) : NaN}
                showDifference={true}
                hidePercentage={true}
                prefix={calculateNpsDifference(nps?.score ?? 0, compareNps?.score ?? 0) > 0 ? "+" : ""}
              />
              </div>
            </Col>
          </Row>
          <Row>
            <Col sm={6} className="adminReportSecTile">
            <div className="MainTileWrap">
                {detailedRatingsIsFetching && <div className="adminReportOverlay"><LoadingSpinner className="my-5" /></div>}
              <div className="tile tileStars">
                <StarElementsTileContainer lng={lang} detailedRatings={detailedRatings} compDetailedRatings={comparDetailedRatings} />
              </div>
              </div>
            </Col>
            <Col sm={6} className="adminReportSecTile">
            <div className="MainTileWrap">
                {highetRatingsIsFetching && <div className="adminReportOverlay"><LoadingSpinner className="my-5" /></div>}
              <div className="tile tileStars">

                <StarElementsTileContainer lng={lang} highestRatings={highetRatings} compHighestRatings={highetRatings} />
              </div>
              </div>
            </Col>
          </Row>
        </Col>
      </Row>
    </Container>
  );
}

export default ModuleReportStatistic;
